import { FC } from "react";
import styled from "styled-components";

const Background: FC = () => {
  return <Root />;
};

export default Background;

const Root = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  top: 0;
  left: 0;
  z-index: -1;
  background-color: #fffcf5;
  display: flex;
  justify-content: space-between;
`;
